enum ViewMode {
  CALENDAR = "calendar",
  LIST = "list",
  SCHEDULER = "scheduler",
}

export default ViewMode;
